<div [hidden]="!isLoading" class="text-xs-center">
  <em class="fas fa-cog fa-spin fa-3x"></em> <span>{{message}}</span>
</div>

